<template>
  <div>
    <el-row
      :gutter="15"
      type="flex"
    >
      <el-col :md="8">
        <div class="is-full-height">
          <el-row>
            <el-col>
              <el-card shadow="never">
                <div slot="header">
                  <h3>Schedule</h3>
                </div>
                <SchedulePickupsTablePeakSchedulesTable :schedule="schedule" />
              </el-card>
            </el-col>
          </el-row>
          <br>
          <el-row>
            <el-col>
              <el-card shadow="never">
                <div
                  slot="header"
                  style="vertical-align: middle;"
                >
                  <el-button
                    class="notes-card-button"
                    type="text"
                    @click.native="$refs.notes.create()"
                  >
                    Add
                  </el-button>
                  <h3 class="notes-card-header">
                    Notes
                  </h3>
                </div>
                <Notes
                  ref="notes"
                  :resource="schedule"
                  truncate
                  paginate
                  pagination-layout="prev, pager, next"
                  :limit="2"
                />
              </el-card>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :md="16">
        <el-card
          shadow="never"
          class="is-full-height"
        >
          <div slot="header">
            <h3>Created Pickups</h3>
          </div>
          <SchedulePickupsTablePeakCreatedPickups :pickups="schedule.created_pickups" />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import SchedulePickupsTablePeakSchedulesTable from '@/components/Application/Manage/SchedulePickups/SchedulePickupsTablePeakSchedulesTable'
import SchedulePickupsTablePeakCreatedPickups from '@/components/Application/Manage/SchedulePickups/SchedulePickupsTablePeakCreatedPickups'
import Notes from '@/components/Notes'
export default {
  components: {
    SchedulePickupsTablePeakSchedulesTable,
    SchedulePickupsTablePeakCreatedPickups,
    Notes
  },
  props: {
    schedule: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .notes-card-header {
    margin-top: 0px;
  }
  .notes-card-button {
    padding-top: 3px !important;
  }
</style>
